// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProposalStatus } from './proposal-status';
import {
    ProposalStatusFromJSON,
    ProposalStatusFromJSONTyped,
    ProposalStatusToJSON,
    ProposalStatusToJSONTyped,
} from './proposal-status';

/**
 * 
 * @export
 * @interface Proposal
 */
export interface Proposal {
    /**
     * 
     * @type {number}
     * @memberof Proposal
     */
    applied_version?: number;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    justification: string;
    /**
     * Snapshot of the section's current value from document_content (arbitrary JSON: string, object, or array).
     * @type {any}
     * @memberof Proposal
     */
    original_value?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    proposal_id: string;
    /**
     * The vendor's proposed replacement value, as authored text. Free-form (may be JSON text); stored and displayed verbatim, not parsed structurally.
     * @type {string}
     * @memberof Proposal
     */
    proposed_value?: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    review_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    reviewed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    reviewed_by?: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    section_reference: string;
    /**
     * 
     * @type {ProposalStatus}
     * @memberof Proposal
     */
    status: ProposalStatus;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof Proposal
     */
    vendor_company: string;
}



/**
 * Check if a given object implements the Proposal interface.
 */
export function instanceOfProposal(value: object): value is Proposal {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('justification' in value) || value['justification'] === undefined) return false;
    if (!('proposal_id' in value) || value['proposal_id'] === undefined) return false;
    if (!('section_reference' in value) || value['section_reference'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('vendor_company' in value) || value['vendor_company'] === undefined) return false;
    return true;
}

export function ProposalFromJSON(json: any): Proposal {
    return ProposalFromJSONTyped(json, false);
}

export function ProposalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Proposal {
    if (json == null) {
        return json;
    }
    return {
        
        'applied_version': json['applied_version'] == null ? undefined : json['applied_version'],
        'created_at': json['created_at'],
        'justification': json['justification'],
        'original_value': json['original_value'] == null ? undefined : json['original_value'],
        'proposal_id': json['proposal_id'],
        'proposed_value': json['proposed_value'] == null ? undefined : json['proposed_value'],
        'review_comment': json['review_comment'] == null ? undefined : json['review_comment'],
        'reviewed_at': json['reviewed_at'] == null ? undefined : json['reviewed_at'],
        'reviewed_by': json['reviewed_by'] == null ? undefined : json['reviewed_by'],
        'section_reference': json['section_reference'],
        'status': ProposalStatusFromJSON(json['status']),
        'user_id': json['user_id'],
        'vendor_company': json['vendor_company'],
    };
}

export function ProposalToJSON(json: any): Proposal {
    return ProposalToJSONTyped(json, false);
}

export function ProposalToJSONTyped(value?: Proposal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applied_version': value['applied_version'],
        'created_at': value['created_at'],
        'justification': value['justification'],
        'original_value': value['original_value'],
        'proposal_id': value['proposal_id'],
        'proposed_value': value['proposed_value'],
        'review_comment': value['review_comment'],
        'reviewed_at': value['reviewed_at'],
        'reviewed_by': value['reviewed_by'],
        'section_reference': value['section_reference'],
        'status': ProposalStatusToJSON(value['status']),
        'user_id': value['user_id'],
        'vendor_company': value['vendor_company'],
    };
}
